import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {OphIconModule} from '../../design/oph-icon/oph-icon.module';

@Component({
  selector: 'task-icon-picker-button',
  templateUrl: './task-icon-picker-button.component.html',
  styleUrls: ['./task-icon-picker-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [OphIconModule],
})
export class TaskIconPickerButtonComponent {
  iconName = input<string>();
  lightBackground = input<boolean>();
  iconFolder = input<string>();

  buttonClick = output<void>();
}
